import { logger } from '@lessonup/logging-classic';
import { ErrorProvider, ErrorProviderProps, ErrorToErrorDisplayMessage } from '@lessonup/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { errorCodeToStandardizedMessage } from './errorCodeToStandardizedMessage';

interface DefaultProps {
  children: React.ReactNode;
  defaultDisplayMode?: ErrorProviderProps['defaultDisplayMode'];
  parsers?: ErrorToErrorDisplayMessage[];
}

export const ErrorProviderWithDefaultTranslations: React.FC<DefaultProps> = ({
  children,
  defaultDisplayMode,
  parsers = [],
}) => {
  const { t } = useTranslation();
  return (
    <ErrorProvider
      defaultDisplayMode={defaultDisplayMode}
      errorParsers={[...parsers, (error) => errorCodeToStandardizedMessage(error, t)]}
      logger={(error) => logger.error(error)}
    >
      {children}
    </ErrorProvider>
  );
};
